// @ utilities
const { setTitleDocument } = require('utilities/multiLanguageHelper');
import { locationPathByCountry } from 'utilities/logicByCountry';

const setInitialTitleDocument = () => {
    setTitleDocument();
};

const getLocationOrigin = () => {
    const locationMainPath = locationPathByCountry[__ORIGIN_COUNTRY__];

    return `${location.origin}${locationMainPath}`;
};

export default {
    setInitialTitleDocument,
    getLocationOrigin,
};
